import { render } from "./FullCalendar.vue?vue&type=template&id=3dc9c577&scoped=true"
import script from "./FullCalendar.vue?vue&type=script&lang=js"
export * from "./FullCalendar.vue?vue&type=script&lang=js"

import "./FullCalendar.vue?vue&type=style&index=0&id=3dc9c577&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc9c577"]])

export default __exports__